<!--
商品详情页头部

使用说明：

<ProductDetailHeader
 :product="{Product}"
 />

Product={
    img: '图片',
    name="'商品名称'",
    price="商品价格",
    sale="已兑换数量"
}

-->

<template>
    <div class="wrap">
        <Icon class="img" :img="image | asProductLargeImage" size="cover" />
        <div class="title">{{title}}</div>
        <div class="info">
            <span class="price-num">{{price}}</span>
            <span class="price-unit">{{priceUnit}}</span>
            <span class="sale">{{sale}}人已兑换</span>
        </div>
    </div>
</template>

<script>
import store from '../../api/store'

export default {
  props: ["product"],
  data(){
    return {
        image: this.product.img,
        title: this.product.title,
        price: this.product.price,
        sale: this.product.sale,
        name: this.product.name,
        priceUnit: store.loginedUser.config.pointName
    };
  },
  methods: {
      setSku(sku){
        this.price = sku.price;
        this.title = sku.title;
        this.image = sku.image;
        this.price = sku.price;
        this.sale = sku.soldCount;
      }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  background: #fff;
  padding-bottom: 4vw;
}

.img {
  width: 100vw;
  height: 100vw;
}

.title {
  width: 90.6vw;
  font-size: 4vw;
  line-height: 1.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  margin: 1.33vw auto;
}

.price-num {
  display: inline-block;
  color: @themeColor;
  font-size: 4.8vw;
  font-weight: bold;
  margin-left: 4.7vw;
}

.price-unit {
  display: inline-block;
  color: @themeColor;
  font-size: 2.93vw;
}

.sale {
  display: inline-block;
  color: #999;
  font-size: 2.93vw;
  margin-left: 4vw;
}
</style>





// WEBPACK FOOTER //
// src/components/products/ProductDetailHeader.vue